/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr } from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import md5 from 'blueimp-md5';

// Proto: auth.User.
export default class User extends Model {
  declare [Type]: 'user';

  @attr('string', { defaultValue: '' })
  declare username: string;

  @attr('string', { defaultValue: '' })
  declare firstName: string;

  @attr('string', { defaultValue: '' })
  declare lastName: string;

  @attr('string', { defaultValue: '' })
  declare profileUri: string;

  @attr('string')
  declare schoolId: string | undefined;

  @attr('string', { defaultValue: '' })
  declare personId: string;

  @attr('string', { defaultValue: '' })
  declare password: string; // Should never be set, except when creating new users.

  @computed('username')
  get image() {
    return `https://gravatar.com/avatar/${md5(this.username)}?d=identicon`;
  }

  @attr('boolean', { defaultValue: false })
  declare disabled: boolean;

  @array('string')
  declare allowedTenantAccess: StatefulArray<string>;

  @array('string')
  declare allowedPeopleAccess: StatefulArray<string>;

  @array('string')
  declare scopes: StatefulArray<string>;

  @array('string')
  declare roles: StatefulArray<string>;

  @attr()
  declare mfaFactors: unknown;

  // Computed
  /**
   * isMfaEnrolled indicates whether the user has at least one MFA factor enabled.
   * @returns {boolean}
   */
  @computed('mfaFactors')
  get isMfaEnrolled() {
    const factors = this.mfaFactors;
    return !isEmpty(factors) && Object.keys(factors as object).length > 0;
  }
}
